import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';
import classNames from 'classnames';
import './SvgAF.css';

import ReactDOM from 'react-dom';

/* Class for svgs with active formatting
    Props:
        img - the default svg to use
        hover - the svg to use when hovered
        forceHover - forces the hover svg to be displayed
        tooltip - text supplied to the ReactToolTip
*/
export default class SvgAF extends Component {
  constructor(props) {
    super(props);

    this.state = {
      img: props.img,
      hovered: false
    };
  }

  componentDidMount() {
    //ReactTooltip.show(this.ref);
    /* this code will make an SvgAF detect if it is already being hovered if it gets rendered under the mouse 
           (firefox seems to create an onMouseEnter event anyway, but chrome won't at least until the mouse is moved). */
    // Commented out because it causes buttons that rerender under the mouse to flicker
    // let node = ReactDOM.findDOMNode(this);
    // setTimeout(() => {
    //     if(node.parentElement.querySelector(':hover') === node)
    //     {
    //         this.setState({img: this.props.hover, hovered: true});
    //     }
    // }, 10);
    ReactTooltip.hide();
    ReactTooltip.rebuild();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.img !== this.props.img || prevProps.hover !== this.props.hover) {
      if (this.state.hovered) {
        this.setState({
          img: this.props.hover
        });
      } else {
        this.setState({
          img: this.props.img
        });
      }
    }
  }

  render() {
    let icon = null;

    if (this.props.active) {
      icon = this.props.active;
    } else if (this.props.forceHover) {
      icon = this.props.hover;
    } else {
      icon = this.state.img;
    }

    if (this.props.log) {
      //console.log("RENDERING SVGAF!!!!  forceHover:", this.props.forceHover, "icon:", icon);
    }

    //console.log("Image:", this.state.img, "type:", typeof this.state.img);
    return (
      <div
        key={this.props.tooltip}
        onClick={() => {
          if (this.props.onClick != null) {
            this.props.onClick();
          }
          ReactTooltip.show(this.ref);
        }}
        className={classNames({
          SvgAF: true,
          SvgAF_Div_Hover: this.state.hovered || this.props.forceHover,
          ...(this.props.customClass && { [this.props.customClass]: true })
        })}
        ref={(ref) => (this.ref = ref)}
        role={this.props.role}
        data-tip={this.props.tooltip ? this.props.tooltip : null}
        data-multiline={this.props.tooltipMultiline ? this.props.tooltipMultiline : null}
        aria-label={this.props['aria-label']}
        aria-disabled={this.props['aria-disabled']}
        onMouseEnter={() => {
          if (this.props.hover) {
            this.setState({ img: this.props.hover, hovered: true });
          }
          ReactTooltip.show(this.ref);
        }}
        onMouseLeave={() => {
          if (this.props.hover && this.state.hovered) {
            this.setState({ img: this.props.img, hovered: false });
          }
          ReactTooltip.hide(this.ref);
        }}
      >
        {
          //if the icon is an object (react component) then we can display it directly. otherwise it should be a string and we can use it as the source for an <img>
          typeof icon === 'object' ? (
            icon
          ) : (
            <img
              className={classNames({ SvgAF_Img_Scale: this.props.scaleImg })}
              src={icon}
              alt={this.props.alt ? this.props.alt : ''}
              draggable="false"
            />
          )
        }
      </div>
    );
  }
}

export class IconAndText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hovered: false
    };
  }

  render() {
    if (this.props.reverse) {
      return (
        <div
          role={this.props.role ?? (this.props.onClick ? 'button' : undefined)}
          aria-disabled={this.props['aria-disabled']}
          className={classNames({
            IconAndText: true,
            IconAndText_Hovered: this.state.hovered,
            ...(this.props.customClass && { [this.props.customClass]: true })
          })}
          onClick={this.props.onClick}
          onMouseEnter={() => this.setState({ hovered: true })}
          onMouseLeave={() => this.setState({ hovered: false })}
          data-tip={this.props.tooltip}
        >
          <span className={classNames({ IconAndText_Text: true, IconAndText_Hidden: this.props.hidden })}>
            {this.props.text}
          </span>
          <SvgAF
            customClass={this.props.imgClass}
            img={this.props.img}
            hover={this.props.hoverImg ? this.props.hoverImg : this.props.img}
            forceHover={this.state.hovered}
          />
        </div>
      );
    } else {
      return (
        <div
          role={this.props.role ?? (this.props.onClick ? 'button' : undefined)}
          aria-disabled={this.props['aria-disabled']}
          className={classNames({
            IconAndText: true,
            IconAndText_Hovered: this.state.hovered,
            ...(this.props.customClass && { [this.props.customClass]: true })
          })}
          onClick={this.props.onClick}
          onMouseEnter={() => this.setState({ hovered: true })}
          onMouseLeave={() => this.setState({ hovered: false })}
          data-tip={this.props.tooltip}
        >
          <SvgAF
            customClass={this.props.imgClass}
            img={this.props.img}
            hover={this.props.hoverImg ? this.props.hoverImg : this.props.img}
            forceHover={this.state.hovered}
          />
          <span
            className={classNames({
              IconAndText_Text: true,
              IconAndText_Hidden: this.props.hidden,
              ...(this.props.textClass && { [this.props.textClass]: true })
            })}
          >
            {this.props.text}
          </span>
        </div>
      );
    }
  }
}
